<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.standing.potential.market.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.standing.potential.market.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th>
            </th>
            <th [i18nKey]="'common.area.working.class'"></th>
            <th [i18nKey]="'common.area.average'"></th>
            <th [i18nKey]="'common.area.wealthy'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.potential.market.size'"></td>
            <td>
                <input type="number" step="1" [disabled]="areParametersReadonly()" [(ngModel)]="parameters.workingClassAreaMarketSize" />
            </td>
            <td>
                <input type="number" step="1" [disabled]="areParametersReadonly()" [(ngModel)]="parameters.averageAreaMarketSize" />
            </td>
            <td>
                <input type="number" step="1" [disabled]="areParametersReadonly()" [(ngModel)]="parameters.wealthyAreaMarketSize" />
            </td>
        </tr>
        </tbody>
    </table>

    <table class="_tableColor">
        <tbody>
            <tr>
                <td [i18nKey]="'parameters.standing.potential.market.growth.rate'"></td>
                <td>
                    <kiwi-percentage-input [(ngModel)]="parameters.marketGrowthRate" [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
        </tbody>
    </table>
</div>
